class DammiLangSwitcher extends HTMLElement {
  connectedCallback() {
    this.innerHTML = `
      <div class="flex items-center bg-slate-100 rounded-full p-1">
        <button data-lang="en" class="lang-btn px-3 py-1 text-xs font-medium rounded-full transition-all text-slate-500 hover:text-slate-800">EN</button>
        <button data-lang="lv" class="lang-btn px-3 py-1 text-xs font-medium rounded-full transition-all text-slate-500 hover:text-slate-800">LV</button>
        <button data-lang="it" class="lang-btn px-3 py-1 text-xs font-medium rounded-full transition-all text-slate-500 hover:text-slate-800">IT</button>
      </div>
    `;
  }
}

customElements.define('dammi-lang-switcher', DammiLangSwitcher);

